import _BaseController from 'Controllers/Web/_BaseController';

import ClinicSearchSelect from 'Vue/Web/Common/Clinic/ClinicSearchSelect.vue';
import ClinicTag from 'Vue/Web/Common/Clinic/ClinicTag.vue';
import 'lazysizes';
import RecommendClinicComponent from 'Vue/Web/Common/RecommendClinicComponent.vue';
import ClinicOnlineMedical from 'Vue/Web/Common/Clinic/ClinicOnlineMedical.vue';
import PrepageMainServices from 'Vue/Web/Common/Clinic/PrepageMainServices.vue';

global.Controller = new (class extends _BaseController {
    ClinicVue?: Vue;

    ready() {
        super.ready();

        this.ClinicVue = new Vue({
            el: '.wrap',
            components: {
                ClinicSearchSelect,
                ClinicTag,
                RecommendClinicComponent,
                ClinicOnlineMedical,
                PrepageMainServices,
            },
        });
    }
})();
